<div class="hpanel">
  <div class="panel-body">
    <div class="flex flex-vertical-center">
      <h4 class="text-primary-2 m-t-none m-b-none">
        {{ invite.firstName }} {{ invite.lastName }}
      </h4>
      <div class="flex-grow"></div>
    </div>
    <table class="table m-t-md">
      <tbody>
        <tr>
          <td><b>Email</b></td>
          <td>
            <a href="mailto:{{ invite.email }}">{{ invite.email }}</a>
          </td>
        </tr>
        <tr>
          <td><b>Roles</b></td>
          <td>
            <ul>
              <li *ngFor="let role of invite.roles">{{ role }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td><b>Coach</b></td>
          <td>
            {{ invite.coach?.firstName || "No " }}
            {{ invite.coach?.lastName || "coach" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!--
    V/§11.7 V-014, 2026-06-26: action-row buttons used to carry inline
    style="margin-right: 3px" and were all .btn-default (ghost) so Link
    (navigation) and Resend (action) had identical visual weight. Now:
    Link is .btn-link (text-only, navigation), Resend stays .btn-default
    (ghost reversible action), Delete is .btn-danger (solid destructive).
    Spacing via flex gap; no inline margins.
  -->
  <div class="panel-footer flex flex-vertical-center">
    <div class="font-semi-bold">Created On {{ invite.createdAt | date }}</div>
    <div class="flex-grow"></div>
    <div style="display: flex; gap: 8px;">
      <a class="btn btn-link" [routerLink]="['/invites', invite._id]">Link</a>
      <button class="btn btn-default" (click)="resendInvite()">Resend</button>
      <button class="btn btn-danger" (click)="deleteInvite()">Delete</button>
    </div>
  </div>
</div>
